import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type Choice = {
    answer: string;
    isCorrect: boolean;
  }
  
  type Question = {
    question: string;
    explanation: string;
    attachment: string;
    figure: string[];
    choices: Choice[];
  }
  
  type QuizDTO = {
    title: string;
    chapterId:string;
    lectureId:string;
    OpenLectureId:string;
    questions: Question[];
  } & ApiError

export const CreateQuiz = (data: QuizDTO): Promise<QuizDTO> => {
    return axios.post("/quiz/create", data)
        .then(response => response.data as QuizDTO);
};
